import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Card, Row, Col, Spinner, Alert } from "react-bootstrap";
import { RiLineChartLine } from "react-icons/ri";
import api from "../../../../common/api";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const chartOptions = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {legend: { display: false }, title: { display: false },
    tooltip: {
      callbacks: {label: (ctx) => ` ${ctx.parsed.x} planset${ctx.parsed.x !== 1 ? "s" : ""}`},
      backgroundColor: "#1e1b4b",
      titleColor: "#e0e7ff",
      bodyColor: "#c7d2fe",
      padding: 10,
      cornerRadius: 8,
    }},
  scales: {
    x: {
      beginAtZero: true,
      ticks: { stepSize: 1, color: "#6b7280", font: { size: 12 } },
      grid: { color: "rgba(107,114,128,0.15)" },
      title: {display: true, text: "Number of Plansets", color: "#6b7280", font: { size: 12, weight: "500" }
      }},
    y: {
      ticks: { color: "#7C3AEDE2", font: { size: 10, weight: "400"} },
      grid: { display: false },
    }}};

export default function PlansetsClientChart() {
  const [sorted, setSorted] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const rawData = await api.get("/planset/top-planset-clients");
        const topClients = rawData.data.top_clients || {};
        const sortedData = Object.entries(topClients).map(([client_id, planset_count]) => ({ client_id, planset_count })).sort((a, b) => b.planset_count - a.planset_count);
        setSorted(sortedData);
        } catch (err) {
        setError(err.message || "Failed to load data.");
        } finally {
        setLoading(false);
        }
    };
    fetchData();
  }, []);

  const hasData = sorted.length > 0;
  const chartData = {
  labels: sorted.map((item) => `${item.client_id}`),
  datasets: [
    {
      label: "Plansets",
      data: sorted.map((item) => item.planset_count),
      backgroundColor: (context) => {
        const { chart } = context;
        const { ctx, chartArea } = chart;

        if (!chartArea) {
          return "#2B7FFF";
        }

        const gradient = ctx.createLinearGradient(
          chartArea.left,
          0,
          chartArea.right,
          0
        );

        gradient.addColorStop(0, "#6366f1");
        gradient.addColorStop(0.5, "#6366f1");
        gradient.addColorStop(1, "#6366f1");

        return gradient;
      },
      borderWidth: 2,
      borderRadius: {
        topLeft: 0,
        topRight: 6,
        bottomLeft: 0,
        bottomRight: 6,
      },
      borderSkipped: false,
    },
  ],
};

  const subtitle = loading ? "Loading..." : error ? "Could not load data" : `Clients ranked by planset`;

  return (
        <Card.Body>
              <Card.Title className="fw-bold mb-1 planset-title">Top Clients by Plansets</Card.Title>
              <Card.Subtitle className="planset-subtitle">{subtitle}</Card.Subtitle>
              <div>
                {error ? <Alert variant="danger" className="mb-0">{error}</Alert>
                 : loading ? <Row className="h-100 align-items-center justify-content-center m-0"><Col xs="auto"><Spinner animation="border" size="sm" /></Col></Row>
                 : !hasData ?
                  <Row className="h-100 flex-column align-items-center justify-content-center m-0">
                    <Col xs="auto"><RiLineChartLine size={20} /></Col>
                    <Col xs="auto"><p className="mb-0">No Data Available</p></Col>
                    <Col xs="auto"><p className="mb-0">No records found</p></Col>
                  </Row>
                 : <Bar data={chartData} options={chartOptions} />
                }
              </div>
        </Card.Body>
  );
}